var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.identiconData)?_c('img',{attrs:{"width":_vm.imageSize + 'px',"height":_vm.imageSize + 'px',"src":'data:image/png;base64,' + _vm.identiconData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }